<ul>
  @for (list of dataList; track $index) {
    <ng-container>
      <li>{{list}}</li>
    </ng-container>
  }
</ul>